import { accMenuItems } from "./config/acc.items";
import { macroMenuItems } from "./config/macro.items";
import { presenteeismMenuItems } from "./config/presenteeism.items";
import { weighingMenuItems } from "./config/weighing.items";
import { configMenuItems } from "./config/config.items";

export const menuItems = [
  ...macroMenuItems,
  ...accMenuItems,
  ...presenteeismMenuItems,
  ...weighingMenuItems,
  ...configMenuItems,
];
